import { createContext, useContext } from 'react';

type FieldWarningEvaluationContextValue = {
  commitValue: (field: string) => void;
  markValueStale: (field: string) => void;
};

export const FieldWarningEvaluationContext =
  createContext<FieldWarningEvaluationContextValue | null>(null);

export function useFieldWarningEvaluation() {
  return useContext(FieldWarningEvaluationContext);
}
